@import '~less/global-variables';
@import './variables';

/*
 * Critical search errors floating on top of the map, at least:
 * - show to non public users
 * - when zoom level is too high
 */
.search-message {
  position: absolute;
  z-index: 1000;
  height: auto;
  padding: 40px 20px;
  top: 40%;
  left: 50%;
  right: 50%;
  color: white;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.7);
  text-align: center;
  background: transparent;
  opacity: 1;

  h4 {
    font-size: 36px;
    font-weight: bold;
  }
  p {
    line-height: 40px;
  }

  // Allows dragging the map trough the element
  pointer-events: none;
  user-select: none;
  button,
  a {
    pointer-events: auto;
  }
  a:not(.btn) {
    color: #fff;
    border-bottom: 2px solid #fff;
    &:active,
    &:hover {
      text-decoration: none;
    }
  }

  // Animate show-hide toggle
  transition: all 0.2s;

  // Make notification responsive
  width: (@search-message-width - 40px);
  margin-left: -(@search-message-width / 2);
  font-size: 24px;
  @media (min-width: @screen-sm-min) {
    @search-message-width: 650px;
    width: (@search-message-width - 40px);
    margin-left: -(@search-message-width / 2);
    font-size: 28px;
  }
}

.search.is-sidebar-open .search-message {
  @media (min-width: @screen-sm-min) {
    left: 54%;
    margin-left: -((@search-message-width / 2));
  }
}

.search-message-solid {
  background: rgba(
    red(@brand-primary),
    green(@brand-primary),
    blue(@brand-primary),
    0.9
  );
  text-shadow: none;
}
